import { apiRequest } from "@/lib/queryClient";

export type CompanyLocation = {
  zipCity: string;
  street: string;
  phone: string;
  email?: string;
};

export const COMPANY = {
  name: 'FassadenCheck',
  legalName: 'Hofer GesmbH',
  brand: 'Hofer Seeboden – Fassade · Putz · Sanierung',
  tagline: 'Von der Analyse direkt zum Angebot. Vom Angebot zur Ausführung. Von der Ausführung zur Rechnung.',
  address: 'Treffling 75b',
  city: '9871 Seeboden',
  phone: '+43 4762 8184718',
  phoneMobile: '+43 699 141414 00',
  email: 'bauleitung@hofer-seeboden.at',
  website: 'https://hofer-seeboden.at',
  // Hofer-Logo (offizielle Quelle); wird im PDF-Header und in der Footer-Box
  // verwendet. Lokal als Asset abgelegt, damit der PDF-Generator das Bild
  // direkt einbetten kann (kein externer Request zur Laufzeit).
  logoUrl: '/assets/hofer-logo.png',
  logoUrl2: '/assets/hofer-logo.png',
  headerLogoUrl: '/assets/hofer-logo.png',
  locations: [
    {
      zipCity: '9871 Seeboden',
      street: 'Treffling 75b',
      phone: '+43 4762 8184718',
      email: 'bauleitung@hofer-seeboden.at',
    },
  ] as CompanyLocation[],
} as const;

export function formatLocationLine(loc: CompanyLocation): string {
  const parts = [`${COMPANY.legalName}`, loc.street, loc.zipCity, loc.phone];
  if (loc.email) parts.push(loc.email);
  return parts.join(' · ');
}

export function getCompanyContactLines(): string[] {
  // Drei kurze Zeilen statt einer überlangen — ergibt sauberere Briefkopf-/PDF-Footer-Darstellung.
  return [
    `${COMPANY.legalName} · ${COMPANY.address} · ${COMPANY.city}`,
    `Tel: ${COMPANY.phone} · Mobil: ${COMPANY.phoneMobile}`,
    `${COMPANY.email} · hofer-seeboden.at`,
  ];
}

/**
 * Synchroner Fallback: erzeugt eine zufällige Angebotsnummer im neuen Format
 * "HS-{Jahr}-{4-stellig}". Nur als Notlösung gedacht, wenn der Server-Zähler
 * (siehe `fetchNextQuoteNumber`) nicht erreichbar ist.
 */
export function generateQuoteNumber(): string {
  const year = new Date().getFullYear();
  const num = String(Math.floor(Math.random() * 9000) + 1000);
  return `HS-${year}-${num}`;
}

/**
 * Holt vom Server die nächste fortlaufende Angebotsnummer für das aktuelle
 * (oder explizit übergebene) Jahr. Format: "HS-{Jahr}-{4-stellig}".
 * Bei Fehler wird auf `generateQuoteNumber()` zurückgefallen.
 */
export async function fetchNextQuoteNumber(year?: number): Promise<string> {
  try {
    const res = await apiRequest("POST", "/api/quotes/next-number", { year });
    const data = (await res.json()) as { formatted?: string };
    if (data?.formatted) return data.formatted;
    return generateQuoteNumber();
  } catch {
    return generateQuoteNumber();
  }
}
